import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "./store";
import Header from "./components/Header";
import Home from "./pages/Home";
import Filmography from "./pages/Filmography";
import Rental from "./pages/Rental";
import Gallery from "./pages/Gallery";
import Stunt from "./pages/Stunt";
import Productions from "./pages/Productions";
import About from "./pages/About";
import Screening from "./pages/Screening";
import Contact from "./pages/Contact";

function ScrollToTop() {
  const { pathname, search } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname, search]);
  return null;
}

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
          <ScrollToTop />
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/filmografia" element={<Filmography />} />
            <Route path="/noleggio-attrezzatura" element={<Rental type="attrezzatura" />} />
            <Route path="/noleggio-costumi" element={<Rental type="costumi" />} />
            <Route path="/galleria" element={<Gallery />} />
            <Route path="/stunt" element={<Stunt />} />
            <Route path="/produzioni" element={<Productions />} />
            <Route path="/chi-sono" element={<About />} />
            <Route path="/contatti" element={<Contact />} />
            <Route path="/proiezione" element={<Screening />} />
            <Route path="*" element={<Home />} />
          </Routes>
          <Toaster theme="dark" position="bottom-right" />
        </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
